// COM-HUBS (2026-08-21): Licitações — Oportunidades + Atestados.
// Atestado é o que prova experiência pra habilitar em edital (decisão Lucas
// 2026-08-21), por isso mora ao lado das oportunidades públicas e não junto
// da carteira de clientes.
//
// 2026-09-02: as abas internas de Licitações (Documentos da empresa e
// Configuração) subiram pro hub — 4 abas no mesmo nível, uma fileira só.
// Configurações é gateada por admin.integracoes.gerenciar (decisão do dono):
// mexer em fonte, filtro e triagem muda o que a empresa inteira enxerga.
//
// 2026-09-22: o 📡 Radar SAIU deste hub e virou item próprio no menu
// (/meu-radar). Motivo em docs/menu-hubs.md: a audiência do hub é a mais larga
// das abas. Em 24/09/2026 ele voltou para o Comercial, mas como hub próprio
// (Comercial › Meu Radar, /comercial/radar, com a aba Atividades ao lado) — é
// a agenda do comercial, não de todo profissional. O botão 📡 continua na
// lista de Oportunidades, que é de onde se acompanha um edital.
// (histórico) 2026-09-21: o Radar nasceu como aba deste hub, logo depois de
// "este edital eu quero acompanhar". Permissão própria porque mexer nele
// muda para qual caixa de entrada o aviso de fim de prazo é enviado.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComercialLicitacoes from '../ComercialLicitacoes';
import ComercialAtestados from '../ComercialAtestados';
import PaginaDocumentosEmpresa from '../comercial-licitacoes/PaginaDocumentosEmpresa';
import PaginaConfiguracoes from '../comercial-licitacoes/PaginaConfiguracoes';
import PipelineLicitacoes from '../comercial-licitacoes/pipeline/PipelineLicitacoes';

// 02/10/2026: o Pipeline de licitações é a aba padrão — é onde se conduz o
// processo (etapas, prazos, decisões). Oportunidades continua sendo a triagem,
// de onde o edital entra no pipeline pelo botão Avaliar. docs/licitacoes-pipeline.md.
const TABS: HubTab[] = [
  { key: 'pipeline',      label: '🧭 Pipeline',               perm: 'comercial.licitacoes.pipeline.ver',           render: () => <PipelineLicitacoes /> },
  { key: 'oportunidades', label: '🏛️ Oportunidades',         perm: 'comercial.licitacoes.oportunidades.ver',      render: () => <ComercialLicitacoes /> },
  { key: 'atestados',     label: '📄 Atestados',              perm: 'comercial.atestados.ver',                     render: () => <ComercialAtestados /> },
  { key: 'documentos',    label: '🗂️ Documentos da empresa',  perm: 'comercial.licitacoes.documentos_empresa.ver', render: () => <PaginaDocumentosEmpresa /> },
  { key: 'configuracoes', label: '⚙️ Configurações',          perm: 'admin.integracoes.gerenciar',                 render: () => <PaginaConfiguracoes /> },
];

export default function ComercialLicitacoesHub() {
  return <HubAbas tabs={TABS} />;
}
